import script from "./OrganizationSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationSummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationSummaryCard.vue?vue&type=style&index=0&id=331f1013&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331f1013"]])

export default __exports__